/* eslint-disable react/jsx-props-no-spreading */
import React, {memo, useRef, useLayoutEffect} from 'react'
import {usePrevious} from './usePrevious'

export interface SingleOTPInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  focus?: boolean
}

export function SingleOTPInputComponent(props: SingleOTPInputProps) {
  const {focus, autoFocus, ...rest} = props
  const inputRef = useRef<HTMLInputElement>(null)
  const prevFocus = usePrevious(!!focus)

  useLayoutEffect(() => {
    if (inputRef.current) {
      if (focus && autoFocus) {
        inputRef.current.focus()
      }
      if (focus && autoFocus && focus !== prevFocus) {
        inputRef.current.focus()
        inputRef.current.select()
      }
      if (focus && focus == prevFocus) {
        inputRef.current.type = 'text'
        inputRef.current.setSelectionRange(
          inputRef.current.value.length,
          inputRef.current.value.length
        )
        inputRef.current.type = 'number'
        inputRef.current.focus()
        // inputRef.current.selectionEnd = inputRef.current.value.length;
      }
    }
  }, [autoFocus, focus, prevFocus])

  return <input ref={inputRef} {...rest} />
}

const SingleOTPInput = memo(SingleOTPInputComponent)

export default SingleOTPInput
